module.exports = __webpack_public_path__ + "static/img/avatar.fc4dbba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar.jpg
// module id = 3SZE
// module chunks = 1